import { render, staticRenderFns } from "./MBALoginPage.vue?vue&type=template&id=690b8422&scoped=true"
import script from "./MBALoginPage.vue?vue&type=script&lang=js"
export * from "./MBALoginPage.vue?vue&type=script&lang=js"
import style0 from "./MBALoginPage.vue?vue&type=style&index=0&id=690b8422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b8422",
  null
  
)

export default component.exports